import { useState, useEffect } from 'react';
import { 
  Box, 
  Container, 
  Grid, 
  Pagination, 
  Select, 
  MenuItem, 
  FormControl, 
  InputLabel,
  Typography,
  Chip
} from '@mui/material';
import { fetchTags, Tag } from '../../api/tagService';
import { TagCard } from './TagCard';

const SORT_OPTIONS = [
  { value: 'popular', label: 'По популярности' },
  { value: 'name_asc', label: 'По имени (А-Я)' },
  { value: 'name_desc', label: 'По имени (Я-А)' },
];

export const TagsPage = () => {
  const [tags, setTags] = useState<Tag[]>([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState('popular');
  const [loading, setLoading] = useState(true);
  const limit = 12;

  useEffect(() => {
    const loadTags = async () => {
      setLoading(true);
      try {
        const { data, total } = await fetchTags((page - 1) * limit, limit);
        
        // Применяем сортировку
        const sortedData = [...data].sort((a, b) => {
          switch (sort) {
            case 'name_asc': return a.name.localeCompare(b.name);
            case 'name_desc': return b.name.localeCompare(a.name);
            default: return b.video_count - a.video_count;
          }
        });
        
        setTags(sortedData);
        setTotal(total);
      } finally {
        setLoading(false);
      }
    };

    loadTags();
  }, [page, sort]);

  return (
    <Container maxWidth={false} sx={{ py: 4 }}>
      <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h4" component="h1">
          Популярные теги
        </Typography>
        
        {/* <Box sx={{ minWidth: 250 }}>
          <FormControl fullWidth>
            <InputLabel>Сортировка</InputLabel>
            <Select
              value={sort}
              label="Сортировка"
              onChange={(e) => setSort(e.target.value)}
            >
              {SORT_OPTIONS.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box> */}
      </Box>

      {/* Список тегов */}
      <Grid container spacing={3}>
        {tags.map((tag) => (
          <Grid sx={{xs: 12, sm:6, md:4, lg: 3}} key={tag.id}>
            <TagCard tag={tag} />
          </Grid>
        ))}
      </Grid>

      {/* Пагинация */}
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <Pagination
          count={Math.ceil(total / limit)}
          page={page}
          onChange={(_, value) => setPage(value)}
          color="primary"
          size="large"
        />
      </Box>
    </Container>
  );
};